import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation } from '@tanstack/vue-query'

export const useRemoveInventoryObject = () => {
  const http = useHttp()
  const { addError } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (objects: number[]) => http.del(`/inventory/objects`, { objects }),
  })

  const remove = async (objects: number[]) => {
    try {
      await mutation.mutateAsync(objects)
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
      throw error
    }
  }

  return {
    ...mutation,

    remove,
  }
}
